import {
  Dialog,
  FlexColumn,
  CodeEditor,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { fontWeight } from '@elementary/common-ui/style/utils';
import { GPGKey } from '../types';
import GPGKeyDetails from './GPGKeyDetails';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  gpgKey: GPGKey;
}

const ShowPublicKeyDialog = ({ isOpen, onClose, gpgKey }: Props) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    title="Public GPG Key"
    confirmText="Close"
    hideCancelButton
    customWidth={800}
    onConfirmButtonClick={onClose}
    message={
      <FlexColumn sx={{ gap: 2 }}>
        <FlexColumn sx={{ gap: 2 }}>
          <GPGKeyDetails gpgKey={gpgKey} />
        </FlexColumn>

        <FlexColumn sx={{ gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: fontWeight('medium') }}>
            Public Key:
          </Typography>
          <CodeEditor
            value={gpgKey.publicKey}
            mode="text"
            readOnly
            height="300px"
            hideLineNumbers
          />
        </FlexColumn>
      </FlexColumn>
    }
  />
);

export default ShowPublicKeyDialog;
